import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/edocai/edocai/app/[lang]/components/Preview.tsx");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/header_chi-siamo.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/blood-cells.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/skull.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/davide.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/giovanni.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/loredana.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/vanessa.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/node_modules/next/dist/client/image-component.js");
